module.exports = __webpack_public_path__ + "static/img/v5.ddcd1f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v5.svg
// module id = Zjqa
// module chunks = 0